export const GET_ADDRESSING_ZIP_CODE = 'GET_ADDRESSING_ZIP_CODE';
export const GET_ADDRESSING_ZIP_CODE_SUCCESS = 'GET_ADDRESSING_ZIP_CODE_SUCCESS';
export const GET_ADDRESSING_ZIP_CODE_ERROR = 'GET_ADDRESSING_ZIP_CODE_ERROR';
